import { useState } from 'react'
import { pdfjs, Document, Page } from 'react-pdf';
import '../App.css'

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
).toString();

const options = {
    cMapUrl: '/cmaps/',
    standardFontDataUrl: '/standard_fonts/',
};

function PoliticaPrivacidade() {
    const [numPages, setNumPages] = useState();

    function onDocumentLoadSuccess(pdfInfo) {
        setNumPages(pdfInfo.numPages);
    }

    return (
        <>
            <div>
                <Document file="SCOTTCLUB - POLÍTICA & TERMOS JUL2023 V4.pdf" onLoadSuccess={onDocumentLoadSuccess} options={options}>
                    {Array.from(new Array(numPages), (el, index) => (
                        <Page
                            key={`page_${index + 1}`}
                            pageNumber={index + 1}
                            scale={1.25}
                            renderAnnotationLayer={false}
                            renderTextLayer={false}
                        />
                    ))}
                </Document>
            </div>
        </>
    )
}

export default PoliticaPrivacidade
